function Contact() {
  return (
    <section className="page-content">
      <h2>Contact</h2>
      <p>If you have questions, please reach out to our team.</p>
      <p>Email: <a href="mailto:asheeshmalpani@yahoo.com">asheeshmalpani@yahoo.com</a>, <a href="mailto:ramanaharnoor@gmail.com">ramanaharnoor@gmail.com</a></p>
      <p>Mobile: <a href="tel:+919901799022">+91 99017 99022</a>, <a href="tel:+918529410802">+91 85294 10802</a></p>
      <p>Address: Jaipur</p>
    </section>
  );
}

export default Contact;
